import { saveAs } from 'file-saver';

export const downloadDocument = (response) => {
  const contentDispositionHeader = response.headers["content-disposition"];
  const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
  const fileName = result.replace(/"/g, '');
  const blob = new Blob([response.data], {
    type: contentDispositionHeader
  });

  saveAs(blob, fileName);
}

export const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

export const buildDocument = (id, name, ext, isSelfService = true) => {
  return {
    BaseDocumentId: id,
    FileName: name,
    FileExtension: ext,
    IsSelfService: isSelfService,
  };
};

export const getDocumentExtension = (documentName) => {
  const nameSplitted = documentName.split('.');
  return nameSplitted.length > 0 ? '.' + nameSplitted[nameSplitted.length - 1] : '';
};

export const validateDocument = (file, settings) => {
  if (!file) return `Upload a file`;
  const ext = getDocumentExtension(file.name);
  const sizeError = 'File size cannot be bigger than ' + settings.MaxFileUpload + 'kb.';
  let errorMessage = settings.AllowedFileTypes.includes(ext) ? '' : 'Extension is not valid';

  errorMessage =
    file.size < settings.MaxFileUpload * 1000
      ? errorMessage
      : errorMessage
        ? errorMessage + 'and ' + sizeError
        : 'File size is too big.';

  return errorMessage;
};

export const buildDocumentV2FromUploadedFile = (DocumentName, IdentificationDocumentTypeCode, fileUploaded, associatedIdCardNumber = null) => {
  return {
    DocumentName,
    IdentificationDocumentTypeCode,
    UploadedFileName: fileUploaded.name,
    AssociatedIDNumber: associatedIdCardNumber,
    Extension: getDocumentExtension(fileUploaded.name),
  };
};

export const convertBufferedMessageToString = (buffer) => {
  var message = String.fromCharCode.apply(null, new Int8Array(buffer));

  //in some cases a json object with an ErrorMessage key is returned, while in other cases a string is returned
  try {
    var obj = JSON.parse(message);

    return obj["ErrorMessage"];
  }
  catch (e) {
    //parsing string from buffer maintains the double quotes so we need to remove them
    return message.substring(1, message.length - 1);
  }
}

export const getDocumentV2FromFile = async (documentType, documentName, fileUploaded) => {
  let docV2 = buildDocumentV2FromUploadedFile(documentName, documentType, fileUploaded, documentName);
  const dataAsString = await toBase64(fileUploaded);
  docV2.Data = dataAsString.split(',')[1].trim();
  return docV2;
}

